module.exports = __webpack_public_path__ + "media/stylesheets/images/mypage/right-arrow-e338d5c5a2189c83d8bb5de89c17a1d1.svg";